// korean.js韩语文件
export default {
	message: {
		language: '언어',
		plogin: '먼저 로그인하세요!',
		login: '로그인',
		login1: '지금 로그인',
		logintips: '로그인 후 더 많은 서비스 이용 가능',
		register: '등록',
		register1: '지금 등록',
		loginout: '종료',
		join: '가입',
		days: '일',
		lastip: '마지막 로그인 IP',
		account: '계정',
		game: '게임',
		video: '비디오',
		collect: '모음집',
		Favorite: '즐겨찾기',
		collect1: '즐겨찾기',
		share: '공유',
		sharelive: '생방송 공유',
		Cache: '캐시',
		download: '다운로드',
		wallet: '지갑',
		recharge: '충전',
		withdraw: '현금 인출',
		noble: '귀족',
		record: '기록',
		RechargeTime: '충전 시간',
		WithdrawalTime: '현금 인출 시간',
		RechargeRecord: '충전 기록',
		WithdrawalRecords: '현금 인출 기록',
		TransactionRecords: '거래 기록',
		business: '비즈니스',
		message: '메시지',
		activity: '혜택',
		setting: '설치',
		help: '도움말',
		version: '버전',
		loggingout: '로그인 종료',
		remember: '비밀번호 기억하기',
		forget: '암호를 잊었습니다.',
		noaccount: '계정 없음',
		returnhome: '첫 페이지로 돌아가기',
		bottomtips: '본 그룹은 필리핀 PAGCOR 및 영국 맨섬 도박협회의 감독을 받아 합법적으로 운영된다',
		days21: '만 21세, 읽기 및 동의',
		rules: '규칙 및 약관',
		hadaccount: '계정 있음',
		gonggao: '공지',
		system: '시스템',
		home: '첫 페이지',
		kefu: '고객 서비스',
		kefuCenter: '고객센터',
		mykf1desc: '다음 전용 APP를 다운로드하여 ID를 추가하여 저에게 문의하십시오.',
		mykf2desc: '다운로드 주소',
		mykf3desc1: '온라인 고객 서비스',
		mykf3desc2: '클릭하여 온라인 채팅 시작',
		mykf3desc3: '충전 불입금, 현금 인출 및 게임 문제 처리',
		my: '나의',
		close: '닫기',
		zuixin: '최신',
		yhdetail: '할인 상세 정보',
		mywallet: '내 지갑',
		zichan: '자산',
		yuan: '원',
		zxwallet: '센터 지갑',
		ptwallet: '플랫폼 지갑',
		transfer: '이체',
		LimitTransfer: '한도 이체',
		cards: '카드 팩 관리',
		gamebalance: '게임 잔액',
		onerecycle: '원클릭 회수',
		Recovery: '회수 금액',
		Recycling: '회수 중',
		wei: '차원',
		loading: '로드 중',
		refreshing: '새로 고침 중',
		refreshend: '새로 고침 성공',
		success: '작업 성공',
		czamount: '충전 금액',
		limit: '한도액',
		saccount: '계정 선택',
		skbank: '수금 은행',
		skname: '수금 이름',
		copy: '복제',
		skcard: '수금 카드 번호',
		submit: '제출',
		Confirmsubmit: '제출 확인',
		nextstep: '다음',
		customerservice: '인력 서비스',
		pleasecontact: '질문이 있으시면 문의하십시오',
		copysuccess: '클립보드에 성공적으로 복사됨',
		copyfail: '복제 실패',
		firstmoney: '충전 금액을 먼저 입력하세요',
		rechargelowtips: '충전 금액은 최저 한도액보다 작을 수 없다',
		rechargeuptips: '충전 금액은 최고 한도액보다 클 수 없다',
		firstaccount: '계정을 선택하십시오.',
		selwallet: '지갑 선택',
		firstoutwallet: '먼저 지갑 밖으로 나가기를 선택하십시오.',
		retract: '집어치우다',
		expend: '확장',
		mzmodel: '무전환 모드',
		mzmodeltips: '오픈 후 잔액이 자동으로 게임장으로 넘어갑니다',
		seloutwallet: '지갑 꺼내기 선택',
		selinwallet: '지갑으로 선택',
		transfertips: '경기장 지갑 사이는 서로 돌릴 수 없다',
		maxamount: '최대 금액',
		codings: '타산량',
		washingAmount: '세탁량',
		withamount: '현금 인출 금액',
		banks: '은행카드',
		withzhtips: '현금인출 계좌를 먼저 묶으세요',
		withmoneytips: '먼저 현금 인출 금액을 입력하십시오.',
		add: '추가',
		antoken1: '세계 최고의 가상화폐 온라인 지갑, 충전 현금 인출 자동 실시간 입금, 이체 거래 더욱 빠르고 안전',
		antoken2: 'AnToken 개인 지갑 앱 다운로드: 클릭 직접 방문 사이트',
		antoken3: 'https://antoken.pro',
		cardtips: '알림: 계정당 5장만 바인딩할 수 있습니다. 수정하시면 삭제 후 다시 추가하세요!',
		walletaddress: '지갑 주소',
		walletaddressdesc: 'ec 시작 34위 영수 조합의 K콩 주소를 기입해 주십시오.',
		USDTaddress: 'USDT 주소',
		unbindingtips: '실히 풀게요?',
		paypass: '결제 비밀번호',
		cardprotocol: '지갑 프로토콜',
		cardaddress: '지갑 주소',
		Cardholder: '카드 소지자',
		bankcard: '은행카드 번호',
		bankname: '계좌 개설 은행',
		banknamedesc: '계좌 개설 은행을 선택하세요.',
		bankaddress: '계좌 개설 주소',
		bankaddressdesc: '계좌 개설 주소를 선택하십시오.',
		bankother: '계좌 개설 지점',
		firstpaypass: '결제 비밀번호를 입력하십시오.',
		bindtips: '정보를 잘 기입해 주십시오. 바인딩 후 수정할 수 없습니다.',
		Paymentcode: '수금 코드',
		platname: '텐다 엔터테인먼트',
		records: '충전 기록',
		gameRecord: '게임 기록',
		betrecord: '게임 주석',
		betDetail: '베팅 상세 정보',
		accountsetting: '계정 설정',
		messages: '내 메시지',
		returnrecord: '환수 기록',
		transferrecord: '이체 기록',
		activityrecord: '이벤트 신청 기록',
		applyfor: '신청',
		welfare: '홍바오',
		query: '질의',
		Time: '시간',
		To: '다음',
		dllogin: '프록시 로그인',
		outsuccess: '종료 성공',
		today: '오늘',
		days7: '최근 7일',
		days14: '최근 14일',
		days30: '근 30일',
		cunkuan: '저금',
		qukuan: '인출',
		ordersn: '주문 번호',
		money: '금액',
		state: '상태',
		nomore: '더 이상 없어요.',
		More: '추가',
		SeeMore: '자세히 보기',
		Detail: '자세히 보기',
		Changebatch: '한 무더기 바꾸다',
		Lovely: '맘에 드는군',
		selplatform: '플랫폼 선택',
		betamount: '베팅 금액',
		betgame: '게임',
		betresult: '베팅 결과',
		perfect1: '더욱 안전한 계정 정보 제공',
		perfect2: '개인 자료를 보완하다.',
		perfect3: '자료가 더욱 완전하고 우리의 서비스가 더욱 빈틈없다',
		perfect4: '완벽해지다',
		binding: '바인딩',
		AddBinding: '새 바인딩',
		carding1: '카드 관리',
		carding2: '현금을 인출하려면 은행 카드 또는 가상 코인 주소를 바인딩하십시오.',
		logpassword1: '로그인 암호',
		logpassword2: '정기적으로 로그인 비밀번호를 수정하여 계정을 안전하게 합니다.',
		paypassword1: '결제 비밀번호',
		paypassword2: '정기적으로 지불 비밀번호를 수정하여 계좌 보안에 유리하다',
		oldloginpass: '원래 로그인 암호',
		newloginpass: '새 로그인 암호',
		oldloginpassdesc: '원래 로그인 암호를 입력하십시오.',
		newloginpassdesc: '새 로그인 암호를 입력하십시오.',
		confirmpass: '암호 확인',
		confirmpassdesc: '확인 암호를 입력하십시오.',
		oldpaypass: '원래 지불 비밀번호',
		newpaypass: '새 결제 비밀번호',
		oldpaypassdesc: '원래 지불 비밀번호를 입력하십시오.',
		newpaypassdesc: '새 결제 비밀번호를 입력하십시오.',
		personalinformation: '자료 편집',
		edit: '편집',
		SelectAll: '모두 선택',
		Delete: '삭제',
		avatar: '프로필 사진 업로드',
		username: '사용자',
		userID: '사용자 ID',
		userIDdesc: '사용자 ID를 입력하십시오.',
		username1: '사용자 이름',
		realname: '이름',
		nickname: '닉네임',
		realname2: '실명',
		realname1: '이름 또는 닉네임',
		realname1desc: '이름 또는 닉네임을 입력하십시오.',
		realnamedesc: '이름을 입력하십시오.',
		nicknamedesc: '닉네임을 입력하십시오.',
		sex: '성별',
		birthday: '생일',
		birthdaydesc: '생일을 선택해주세요.',
		email: '메일박스',
		phone: '핸드폰 번호',
		nationality: '국적',
		nationalitydesc: '국적을 입력하십시오.',
		education: '학력',
		educationdesc: '학력을 입력하십시오.',
		AnnualSalary: '연봉',
		AnnualSalarydesc: '연봉을 입력하세요',
		work: '작업',
		workdesc: '작업을 입력하십시오.',
		RegistrationTime: '등록 시간',
		LastLogin: '마지막 로그인',
		operate: '작업',
		mail: '역내 편지',
		allplat: '전체 플랫폼',
		upgrade: '업그레이드',
		draw: '수령',
		Received: '수령',
		totaldraw: '누적 수령',
		undraw: '수령 대기 중',
		transin: '전입',
		transout: '전출',
		transtype: '거래 유형 선택',
		walfareinfo: '홍바오 상황',
		help1: 'Hi, 존경하는 회원 사용자',
		help2: '도움말 센터에 오신 것을 환영합니다.',
		help3: '만약 관련 문제가 여전히 해결되지 않았다면, 온라인 고객센터에 문의할 수 있다',
		ungot: '미달',
		got: '기준 도달',
		totalrecharge: '누적 충전',
		totalwater: '누적 유수',
		waterratio: '환수 비율',
		jinji: '진급',
		lijin: '축의금',
		level: '등급',
		hot: '인기',
		live: '실물',
		slot: '전자',
		chess: '보드',
		sports: '스포츠',
		lottery: '복권',
		fishing: '고기잡이',
		actrules: '활동 규칙',
		accountlogin: '계정 비밀번호 로그인',
		mobilelogin: '핸드폰 빠른 로그인',
		password: '암호',
		newpassword: '새 암호',
		pleaseaccount: '계정 이름을 입력하십시오.',
		passtips: '암호 길이는 6-15자입니다. 문자와 숫자로 구성되어야 합니다!',
		pleasepass: '암호를 입력하십시오.',
		pleasetwcode: '그림 인증 코드를 입력하십시오.',
		country: '국가 / 휴대폰 번호',
		pleasemobile: '드폰 번호를 입력하세요.',
		yzm: '인증 코드',
		pleaseyzm: '핸드폰 인증번호를 입력하세요.',
		sendcode: '인증 코드 보내기',
		currency: '화폐 종류',
		usernametips: '영숫자를 포함하여 4-16자리 문자를 입력하십시오.',
		currencytips: '코인을 선택하세요',
		againpass: '위 암호를 다시 입력합니다.',
		ckmoney: '예금 금액',
		ckdate: '예금일',
		redmoney: '보너스 금액',
		activitycenter: '활동',
		lucrative: '보급',
		MemberManagement: '회원 관리',
		CommissionSettlement: '커미션 결제',
		CommissionRecords: '커미션 기록',
		FriendTransfer: '친구 이체',
		nightMode: '심야 모드',
		Mobileauth: '휴대폰 인증',
		Certified: '인증',
		nodata: '데이터가 없어요.',
		Sportslive: '스포츠 생방송',
		MemberID: '회원 ID',
		MemberIDdesc: '회원 ID를 입력하십시오.',
		friendID: '친구 ID',
		friendIDdesc: '친구 ID 또는 핸드폰 번호를 입력하십시오.',
		findMember: '회원을 되찾다',
		Platformfees: '플랫폼 비용',
		PromotionalMaterials: '소재를 널리 보급하다.',
		copylink: '링크 주소 복사',
		SaveQRcode: 'QR코드 저장',
		interest: '관심',
		eliminate: '제거',
		Recommend: '추천',
		new: '새',
		searchfor: '검색',
		searchfordesc: '검색 내용을 입력하십시오.',
		find: '찾기',
		results: '결과',
		Cashier: '계산대',
		skip: '건너뛰기',
		Enterimmediately: '즉시 진입',
		APPlock: 'APP 응용 프로그램 잠금',
		actTime: '활동 시간',
		confirm: '확인',
		platformtype: '플랫폼 유형',
		orderState: '주문 상태',
		gameName: '게임 이름',
		gameNamedesc: '게임 이름을 입력하십시오.',
		bettime: '베팅 시간',
		validamount: '베팅 금액',
		winloss: '당첨금',
		betnum: '게임 번호',
		normal: '정상',
		abnormal: '비정상',
		betTotal: '총 베팅 금액',
		winTotal: '당첨금 총액',
		Orderamount: '주문 금액',
		Orderbet: '주문 주량',
		male: "남자",
		female: "여자",
		electron: "비디오 게임",
		Dailyvideo: "일일 동영상 추천",
		Choicevideo: "정선 추천",
		videoList1: "매일 최신 업데이트",
		videoList2: "인기 베스트 비디오",
		videoList3: "무료 동영상", //短視頻
		mydata1: "영화 VIP 남은 일수",
		mydata2: "회수 대기 금액",
		waterAmount: "환수 금액",
		waterDate: "귀수일",
		noblet1: 'VIP 업그레이드 즉시 전역 HD 무제한 보기',
		noblet2: '선착순 빨리 사재기 하세요.',
		noblet3: '무한히 보기, 증정',
		noblet4: 'VIP 구매 기록 보기',
		noblet5: '여기를 클릭',
		order1: '회',
		Transamount: '전출 가능 금액',
		Dailylimit: '일일 한도액',
		vipIDdesc: '회원 ID나 핸드폰 번호를 입력하세요.',
		Transferaccount: '계좌로 이체하다',
		Transfermoney: '전입 금액',
		Transfert1: '주: 우대 이벤트 참여, 인출 제한 입금 불가',
		Transfert2: '참고: 제출이 완료되면 시스템은 10분 이내에 입금됩니다. 입금되지 않으면 고객센터에 문의하십시오.',
		amount: '금액',
		receiptTime: '입금 시간',
		Transferfriends: '친구에게 전달',
		Transferringfriends: '친구로 전입 하다',
		Descriptive: '설명 정보',
		exchangerate: '실시간 환율',
		Accountbalance: '계좌 잔액',
		withdrawal: '현금 인출에 필요한 타산량',
		commission: '수수료',
		Exchangerate: '환율 계산',
		illustrate: '설명',
		withdrawtilt1: '최저 현금 인출은 100건이며, 입금되지 않으면 즉시 온라인 고객센터에 연락하십시오.',
		withdrawtilt2: '은행카드를 인출하려면 반드시 본인의 은행카드여야 합니다. 그렇지 않으면 입금할 수 없습니다.',
		tips: '힌트',
		findvipt1: '이 기능을 통해 바인딩에 성공하지 못한 하위 회원을 찾을 수 있습니다.',
		findvipt2: '바인딩 등록 기간 3일 이내의 하급 회원을 제한합니다.',
		Totalplatformcost: '총 플랫폼 비용',
		Winlamount: '승패 금액',
		PlatformRate: '플랫폼 요금',
		totalExpenses: '비용 총액',
		commission1: '현재 커미션 비율',
		commission2: '커미션 비율',
		Mycommission: '내 커미션',
		totalRecharge: '충전 총액',
		totalWithdraw: '현금 인출 총액',
		totalPeople: '회원 수',
		activePeople: '활성 회원',
		addPeople: '이달 신규',
		SettlementDate: '결제 날짜',
		DayMonth: '일 / 월',
		ImmeSettle: '즉시 결제',
		Formula: '계산 공식',
		SettleMoney: '이미 수령한 커미션 금액',
		Date: '날짜',
		authname: '인증 이름',
		authnamedesc: '송금인의 이름을 기입해 주십시오.',
		hashelp: '도움이 필요한 경우',
		contact: '고객 서비스에 문의',
		Agreement: '계약 / 통화',
		ckNumber: '예금 개수',
		cbaddress: '충전 주소',
		notes: '설명',
		Scancoins: '코드를 스캔하여 동전을 충전하다.',
		content: '내용',
		ckdesc: '예금 상세 정보를 입력하십시오.',
		zfAccount: '지급 계좌',
		zfbank: '지불은행',
		banktype: '충전 유형',
		banktypedesc: '충전 종류를 선택하세요',
		zzzh: '계좌 이체',
		zjzh: '계좌로 이체하다',
		whole: '모두',
		zzmoney: '이체 금액',
		zhtime: '이체 시간',
		zzpt: '이체 플랫폼',
		Paymentmethod: '지불 방식',
		behalf: '친구 대리 지불',
		saccountdesc: '수금 계좌를 선택하세요',
		cztips: '이체 금액은 이상의 계좌에 가서 양식을 제출하십시오. 직원이 가장 먼저 당신을 위해 처리할 것입니다.',
		currency1: '화폐',
		exchangeRate1: '환율',
		Rebate: '리베이트',
		Receive1: '입금하다',
		PaymentVoucher: '결제 자격 증명 업로드',
		DepositTime: '예금 시간',
		DepositTimedesc: '예금 시간을 선택하세요',
		BlockchainID: '블록체인 ID',
		BlockchainIDdesc: '블록체인 ID를 입력하십시오.',
		tradeID: '거래 ID 하위 6자리',
		tradeIDdesc: '거래 ID 다음 6자리를 입력하십시오.',
		withdraw1: '현금을 인출하여 입금하다.',
		gamenoIndesc: '게임 유지 관리 중, 잠시 후에 다시 시도하세요~',
		cznamedesc1: '처음 온라인 충전, 실명을 바인딩해야 합니다.',
		cznamedesc2: '이 성명이 예금자의 성명과 일치하는지 확인하십시오. 그렇지 않으면 입금할 수 없습니다.',
		cznamedesc3: '제출 저장 후 변경할 수 없습니다. 자세히 기입해 주십시오.',
		txnamedesc1: '첫 번째 바인딩 정보는 실제 이름을 바인딩해야 합니다.',
		txnamedesc2: '이 성명이 인출인의 성명과 일치하는지 확인하십시오. 그렇지 않으면 입금할 수 없습니다.',
		txnamedesc3: '제출 저장 후 변경할 수 없습니다. 자세히 기입해 주십시오.',
		modify: '수정',
		inviteId: '초대 코드',
		findpaypass: '결제 비밀번호 찾기',
		Movies: '영상',
		rakeback: '환수',
		rescue: '구원',
		RedeemCode: '교환 코드',
		dhTitle: '내 환전 기록',
		dhtxt: '환전',
		dhtxtbtn: '지금 교환',
		dhtxtdesc: '교환 코드 입력',
		dhmoney: '환전 금액',
		dhlsbs: '유수 배수',
		lqtime: '수령 시간',
		free: '무료',
		zznamedesc1: '반드시 계좌이체자의 실명을 기입해 주십시오. 그렇지 않으면 자동으로 입금할 수 없습니다.',
		zznamedesc2: '10분 이내에 충전 금액이 입금되지 않으면 온라인 고객센터에 연락하십시오.',
		tgrs: '현재 보급 인원수',
		tglink: '프로모션 링크',
		tgyqewm: '초대 QR코드',
		wxts: '따뜻한 힌트',
		tgtips1: '독립 도메인 이름을 신청하려면 대리 전원에게 연락하십시오.',
		tgtips2: '만약 당신이 역장이라면 광고 소재가 필요하면 고객센터에 연락하세요.',
		tgtips3: '친구 등록을 요청합니다. 당신의 친구가 등록할 때 초대 코드를 기입하기만 하면 됩니다.',
		mycenter: '개인 센터',
		myInfo: '개인 정보',
		mylucrative: '나의 홍보',
		Security: '계정 보안',
		timeframe: '시간 범위',
		starttime: '시작 시간',
		endtime: '종료 시간',
		Keysdesc: "국가를 선택하세요",
		Keysdesc1: "지역 코드를 선택하십시오.",
		rule1: '만 21세, 읽기 및 동의',
		rule2: '[규칙 및 조항]',
		autotrans:'자동 회전 면제',
		autotranstips:'게임 시, 잔액은 자동으로 해당 게임 계좌로 이체됩니다',
		handtrans:'수동 이체',
		handtranstips:'수동 이체를 원하시면 【자동 무전】 종료',
		jytype:'거래 유형',
		wechat:'위챗',
		Alipay:'알리페이',
		yjed:'커미션 한도',
		yjsed:'결제된 한도',
	},
	footer: {
		fkfs: '결제 방법',
		partners: '동업자',
		followUs: '관심 가져',
		regauth: '규제 기관',
		pagcor: 'PAGCOR',
		legalage: '법정 연령',
		cs: '고객 서비스',
		telegram: '비행기',
		network: '인터넷',
		dark: '야간',
		byday: '낮',
		affiliate: '연관',
		TOP: '상단',
		chat: '채팅',
	},
	home: {
		hotgametit: "인기 게임",
		activitydesc1: "초특급 예우를 갖추다.",
		activitydesc2: "친구를 부르고 채금을 모아 함께 벌다.",
		new: "최신",
		Chesscardsdesc1: "국제 바둑판",
		Chesscardsdesc2: "생생한 게임 환경",
		Chesscardsdesc3: "사실적인 인공 지능,",
		Chesscardsdesc4: "다양한 모드와 새로운 게임 방식",
		Chesscardsdesc5: "하이엔드 보드게임, 대박 플랫폼..",
		lotterydesc1: "복권",
		lotterydesc2: "고전적이고 혁신적인 복권 게임과",
		lotterydesc3: "욕심을 돋우는 게임 과정입니다.",
		onsitedesc1: "LIVE CASINO",
		onsitedesc2: "우리는'서비스 지상'의 이념을 가지고 많은 회원 게이머들에게 제공하기 위해 힘쓰고 있다",
		onsitedesc3: "가장 풍부한 온라인 도박 게임과 다양한 고가치 서비스 시스템",
		placeholderdesc: "게임 이름을 입력하십시오.",
		gogamebtn: "게임에 들어가다",
		swgamebtn: "게임 테스트",
		swbtn: "시험 게임",
		egamesdesc1: "모바일 게임 소프트웨어",
		egamesdesc2: "세계 최고의 비디오 게임 공급업체,",
		egamesdesc3: "주로 오프라인과 온라인 비디오 게임 개발에 종사한다.",
		egamesdesc4: "아시아 최대의 오락 도시를 가지고 있다",
		livedesc1: "Casino Live",
		livedesc2: "AG ALLBET  OG DS ",
		livedesc3: "최고의 엔터테인먼트 플랫폼",
		livedesc4: "용호, 금화튀김, 색접시, 번점 등 놀이탁자 대임군이 고르고,",
		livedesc5: "럭셔리한 환경을 경험해 보십시오!",
		sportdesc1:"스포츠",
		sportdesc2:"대부분의 유형의 베팅, 최고의 베팅 경험,",
		sportdesc3:"조기 현금화 지원,",
		sportdesc4:"쌀 모으기 한 발짝 빨리 네 생각을 생각해，",
		sportdesc5:"당신이 좋아하는 사람에게 투표하세요.",
		fishdesc1:"고기잡이",
		fishdesc2:"미친 낚시!초고폭발",
		fishdesc3:"속도, 거대한 보물이 네가 잡으러 가기를 기다리고 있어!",
		tiptitle: '중요 알림',
		tipclose: '닫기',
		tipflag: '오늘은 알리지 않는다',
		testdesc1: "최신 공식 웹 사이트",
		testdesc2: "알림: 최소 MS 숫자의 웹 주소가 더 빨리 열립니다!",
		LinkTimeout: "링크 시간 초과",
		GoImmediately: "즉시 이동",
		Recheck: "액세스 속도 다시 확인",
		Enter:'진입',
	},
	help: {
		title0: '우리에 대해',
		title1: '자주 묻는 질문',
		title2: '개인 정보 보호 정책',
		title3: '면책 성명',
		title4: '연락처',
		title5: '대리 가맹',
		title6: '도박 책임',
		title7: '비즈니스 협력',
		service: '온라인 고객 서비스',
		servicedesc: '신속하고 편리하며 적시에 커뮤니케이션 제공',
	},
	download: {
		scantxt: 'QR코드 스캔 APP 다운로드',
		downtext: "APP 다운로드",
		downdesc: "지금 TDBET 계좌를 개설하고 가장 우대적인 보너스를 받으세요!",
		version: "버전",
		ScanCodedown: "코드를 스캔하여 APP를 다운로드하다.",
		BeCurrent: "공통",
		H5org: "H5 페이지 액세스",
	},
	vip: {
		viptitle: "등달 VIP",
		viptitle1: "최고의 축제",
		viptitle2: "영광스럽게 출항하다",
		viptitle3: "텐다 VIP에 가입하여 최고의 지존 서비스를 누리세요",
		vipen: "BECOME A VIP MEMBER AND ENJOY THE MOST HONORBLE SERVICE",
		totalDeposit: "누적 충전",
		totalBet: "누적 유수",
		vipBLdesc: "VIP 환수 비율",
		vipgradetitle: "VIP 레벨",
		vipgrade1: "실물",
		vipgrade2: "전자",
		vipgrade3: "보드",
		vipgrade4: "스포츠",
		vipgrade5: "복권",
		vipgrade6: "e스포츠",
		ActivityRules: "활동 규칙",
		Rulestext1: "승진 기준",
		Rulesdesc1: "회원의 누적 예금 및 누적 유수가 해당 레벨의 요구에 도달하면 다음날 24시까지 해당 VIP 레벨에 진급할 수 있습니다.",
		Rulestext2: "승진 순서",
		Rulesdesc2: "VIP 등급은 상응하는 요구에 도달하면 매일 1급씩 진급할 수 있지만, VIP 등급은 등급을 초과하여 진급할 수 없다.",
		Rulestext3: "보급 요구",
		Rulesdesc3: "회원은 모 VIP등급에 도달한후 90일내에 베팅하려면 등급유지류수요구를 완성해야 한다.만약 이 기간에 승진을 완성한다면 보급요구는 다시 현재 등급에 따라 계산한다.",
		Rulestext4: "성능 저하 기준",
		Rulesdesc4: "회원이 한 분기 (90일 계산) 내에 해당 보증 요구 사항을 충족하지 못하면 시스템은 자동으로 한 등급을 강등하고 해당 환수 및 기타 혜택도 강등 후 등급으로 조정된다.",
		Rulestext5: "승급 예금",
		Rulesdesc5: "업그레이드 축의금은 회원이 해당 회원 레벨에 도달하면 시스템이 자동으로 발송되며, 각 레벨의 업그레이드 축의금은 회원 한 명당 1회만 획득할 수 있다 (업그레이드 축의금 1배 유수 인출할 수 있다).",
		Rulestext6: "생일 축의금",
		Rulesdesc6: "회원은 등록 3개월 이내에 생일을 보내며, 올해는 생일 축의금을 받을 수 없다.또 가입 기간이 3개월 이상인 회원은 생일 당일 VIP 페이지에서 셀프 수령해야 하며, 연 1회 수령할 수 있다.(생일 축의금은 1배의 흐르는 물로 인출할 수 있다.)",
		Rulestext7: "매월 보너스",
		Rulesdesc7: "회원은 지난달에 최소 1회 예금 성공 기록이 있으면 다음 달 1일과 16일에 각각 VIP 페이지를 방문하여 당일 해당 등급의 매월 홍바오 컬러 골드의 1/2을 수령할 수 있다 (홍바오 선물은 1배의 물이 흐르면 인출할 수 있다)",
		Rulestext8: "텐다오락오락은 활동에 대한 수정, 정지 및 최종 해석권을 보류한다.",
		Rulesdesc8: "비고: 이상은 각 경기장 최고 귀수이며, 구체적인 귀수 금액은 실제 게임을 기준으로 하시기 바랍니다. 매일 귀수는 다음날 15: 00-16: 00에 순차적으로 지급됩니다.",

	},
}


// WEBPACK FOOTER //
// ./src/lang/korean.js